export const LOCAL_STORAGE_KEYS = Object.freeze({
    MATCHING_STORAGE: 'matchingStorage'
})

export const AI_CONTEXT_KEYS = Object.freeze({
    TENANT_NAME: 'fcr_tenant_name',
    AGENTS: 'agents'
})

export const AI_AGENT_NAMES = Object.freeze({
    FCR: 'agp-fcr-agent'
})

export const STAGING_TABLE_REPORT_FILE_PATH =
    '/Global/Administration/Diagnostics/Visualize Staging Table';
